import { render, staticRenderFns, recyclableRender, components } from "./certification-results.vue?vue&type=template&id=339ca964&scoped=true&"
var renderjs
import script from "./certification-results.vue?vue&type=script&lang=js&"
export * from "./certification-results.vue?vue&type=script&lang=js&"
import style0 from "./certification-results.vue?vue&type=style&index=0&id=339ca964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ca964",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/certification-results/certification-results.vue"
export default component.exports